import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { MarqueeBanner } from "@/components/MarqueeBanner";
import { HomeAbout } from "@/components/AboutStory";
import { TrustBadges } from "@/components/TrustBadges";
import { AppTunnels } from "@/components/AppTunnels";
import { MedusaPromo } from "@/components/MedusaPromo";
import { TestimonialsSection } from "@/components/TestimonialsSection";
import { FanMailWall } from "@/components/FanMailWall";
import { GetAppSection } from "@/components/GetAppSection";
import { NewsletterSection } from "@/components/NewsletterSection";
import { Footer } from "@/components/Footer";

export default function LandingPage() {
  return (
    <main className="bg-obsidian text-ice" data-testid="landing-page">
      <Navbar />
      <Hero />
      <MarqueeBanner />
      <MedusaPromo />
      <HomeAbout />
      <AppTunnels />
      <TrustBadges />
      <TestimonialsSection />
      <FanMailWall />
      <GetAppSection />
      <NewsletterSection />
      <Footer />
    </main>
  );
}
